// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"cf581a68","415":"4f28b1b4"}[chunkId] + ".chunk.js";
};